import React from "react";
import styled from "styled-components";
import ReviewStars from "./ReviewStars.tsx";

const ReviewContainer = styled.div`
  display: flex;
  width: 90%;
  flex-direction: column;
  gap: 4px;
  border-bottom: 1px solid var(--background-green);
  align-self: center;
  padding: 12px;
  margin-bottom: 8px;
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;
  justify-content: space-between;
  font-size: 10px;
`;

const HeaderDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const Name = styled.div`
  font-size: 18px;
  color: var(--primary-font-color);
`;

const Date = styled.div`
  font-size: 12px;
  color: var(--tertiary-font-color);
`;

const Comment = styled.div`
  font-size: 14px;
  color: var(--primary-font-color);
  padding: 4px;
`;

interface Props {
  rating: number;
  name: string;
  review: string;
  date: string;
}

const ReviewTile: React.FC<Props> = ({ rating, name, review, date }) => {
  const formatDate = date.split("T")[0];
  return (
    <ReviewContainer>
      <Header>
        <HeaderDetails>
          <Name>{name}</Name>
          <Date>
            {" "}
            {"- "}
            {formatDate}
          </Date>
        </HeaderDetails>

        <ReviewStars rating={rating} />
      </Header>
      <Comment>{review}</Comment>
    </ReviewContainer>
  );
};

export default ReviewTile;
